import { useEffect, useState } from "react";
import moment from "moment";
import {
	focusElemnt,
	formatDate,
	navigation1,
	navigation3,
} from "../../../../../utilityFunctions";
import ReportHeader from "../../../../common/ReportHeader";
import CustomDatePicker from "../../../../common/CustomDatePicker";
import { Grid, Box, Button } from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getTotalByKey } from "../../../../generics/helper";
import { callAddFontRobotoBold } from "../../../../../assets/fonts/Roboto-bold";
import { callAddFontRobotoNormal } from "../../../../../assets/fonts/Roboto-normal";
import { excelConfig } from "../../../../../assets/extra/excelConfig";
import excelExport from "../../../../../assets/extra/export-excel";
import MultiSelectDropDown from "../../../../form-components/MultiSelectDropDownComponent";
import {
	cancelData,
	columnDefsPDF,
	columnDefs2,
	columnDefs3,
	statusData,
} from "./constants";
import { useDispatch, useSelector } from "react-redux";
import {
	CountersfilterList,
	getBusStationListAll,
	getCorporationList,
	getPaymentGatewayList,
} from "../../../../../redux/KSRTC_Redux/MasterConfig/MasterAction";
import { getPOSBankGatewayReportData } from "../../../../../redux/KSRTC_Redux/ReportsPage/ReportsAction";
import Alert from "../../../../common/Alert";
import {
	calculateDynamicFormatLandscape,
	calculateDynamicFormatPortrait,
	calculateTotalTableWidth,
} from "../../AccountsReports/PreponePostpone/Constants";
import { onlineReportMenu, reportMenu } from "../../../../../redux/Actions";
import PosBankGateWayWiseBookingStatementFailureTable from "./PosBankGateWayWiseBookingStatementFailureTable";
import PosBankGateWayWiseSuccessStatementTable from "./PosBankGateWayWiseSuccessStatementTable";
import { getUserList } from "../../../../../redux/KSRTC_Redux/userConfig/UserAction";

const PosbankGateWayWiseBookingStatement = () => {
	const dispatch = useDispatch();
	const store = useSelector((store) => store);
	const { user, masterConfig } = store;
	const userState = useSelector((store) => store.user);
	const { userList } = useSelector((store) => store.userConfig);
	const [selData, setSelData] = useState({
		bookedDate: formatDate(window.getTime ? window.getTime() : new Date()),
		busStation: [],
		counter: [],
		user: [],
		status: [statusData?.[0]],
	});
	const [filterUserList, setFilterUserList] = useState([]);
	const [showAlert, setShowAlert] = useState(false);
	const [alertMsg, setAlertMsg] = useState("");
	const [busStationList, setBusStationList] = useState([]);
	const [counterList, setCounterList] = useState([]);
	const currentDateTime = moment(
		window.getTime ? window.getTime() : new Date()
	).format("DD-MMM-YYYY HH:mm");
	const handleResetValue = () => {
		let busStationOpt = masterConfig?.busStationList?.map((val) => ({
			...val,
			BranchCodeName: `${val?.BranchName}(${val?.BranchCode})`,
		}));
		let counterCode = masterConfig?.countersFilter?.map((val) => ({
			...val,
			CounterNameCode: `${val.CounterName} (${val.CounterCode})`,
		}));
		setSelData({
			bookedDate: formatDate(
				window.getTime ? window.getTime() : new Date()
			),
			busStation: busStationOpt,
			counter: counterCode,
			user: userList?.filter((val) => val.UserID === userState?.UserID),
			status: [statusData?.[0]],
		});
	};
	const [reportTableData, setReportTableData] = useState([]);
	const [reportType, setReportType] = useState(0);

	useEffect(() => {
		focusElemnt("bookedDate");
	}, []);

	useEffect(() => {
		if (user.CompanyID) {
			const busStationBody = {
				CompanyID: user?.CompanyID,
				BranchID: 0,
				IsOutStation: -1,
			};
			dispatch(
				getBusStationListAll(busStationBody, true, 60 * 60 * 1000)
			);
			const counterBody = {
				CounterID: 0,
				BranchID: 0,
				CounterTypeID: 0,
				CompanyID: user?.CompanyID,
			};
			dispatch(CountersfilterList(counterBody));
			const CorporationBody = {
				CorporationID: 0,
				ClientID: user?.CompanyID === 1 ? 1 : 2,
			};
			dispatch(getCorporationList(CorporationBody, true, 60 * 60 * 1000));
			const paymentGatewayBody = { PGID: 0 };
			dispatch(
				getPaymentGatewayList(paymentGatewayBody, true, 60 * 60 * 1000)
			);
			const userBody = {
				CompanyID: userState?.CompanyID,
				UserID: 0,
				BranchID: 0,
			};
			dispatch(getUserList(userBody));
		}
	}, [user.CompanyID]);

	useEffect(() => {
		let busStationOpt = masterConfig?.busStationList?.map((val) => ({
			...val,
			BranchCodeName: `${val?.BranchName}(${val?.BranchCode})`,
		}));
		let counterCode = masterConfig?.countersFilter?.map((val) => ({
			...val,
			CounterNameCode: `${val.CounterName} (${val.CounterCode})`,
		}));
		setBusStationList(busStationOpt);
		setSelData((prev) => ({
			...prev,
			busStation: busStationOpt,
		}));
		setCounterList(counterCode);
		setSelData((prev) => ({
			...prev,
			counter: counterCode,
		}));
	}, [masterConfig]);

	useEffect(() => {
		if (userList?.length > 0) {
			const addLoginIdToUser = userList?.map((val) => ({
				...val,
				UserName: `${val.UserName} (${val.LoginID})`,
			}));
			setSelData((prev) => ({
				...prev,
				user: addLoginIdToUser?.filter(
					(val) => val.UserID === userState?.UserID
				),
			}));
			setFilterUserList(addLoginIdToUser);
		}
	}, [userList]);

	const busStationProps = () => {
		return {
			id: "station",
			width: "100%",
			name: "station",
			label: " ",
			isCompulsory: false,
			options: busStationList || [],
			preSelectedValues: selData.busStation || [],
			searchPlaceholder: "Search by Station",
			disabled: false,
			isObject: true,
			primaryKey: "BranchID",
			labelKey: "BranchCodeName",
			singleSelect: true,
			selectAllOption: true,
			defaultAllSelected: true,
			prevId: "bookedDate",
			nextId: "counter",
			searchByCode: true,
			searchByName: "BranchCode",
		};
	};
	const counterProps = () => {
		return {
			id: "counter",
			width: "100%",
			name: "counter",
			label: "",
			isCompulsory: false,
			options: counterList || [],
			preSelectedValues: selData.counter || [],
			searchPlaceholder: "Search by Counter",
			disabled: false,
			isObject: true,
			primaryKey: "CounterID",
			labelKey: "CounterNameCode",
			singleSelect: true,
			selectAllOption: true,
			defaultAllSelected: true,
			prevId: "station",
			nextId: "user",
			searchByCode: true,
			searchByName: "CounterCode",
		};
	};
	const userNameProps = () => {
		return {
			id: "user",
			width: "100%",
			name: "User",
			label: "User",
			isCompulsory: false,
			options: filterUserList || [],
			preSelectedValues: selData?.user || [],
			searchPlaceholder: "Search by User",
			disabled: false,
			isObject: true,
			primaryKey: "UserID",
			labelKey: "UserName",
			singleSelect: true,
			selectAllOption: true,
			defaultAllSelected: true,
			prevId: "counter",
			nextId: "status",
			listWidth: "max-content",
			searchByCode: true,
			searchByName: "LoginID",
		};
	};
	const statusProps = () => {
		return {
			id: "status",
			width: "100%",
			name: "Selectstatus",
			// label: "Success",
			isCompulsory: false,
			options: statusData || [],
			preSelectedValues: selData.status,
			searchPlaceholder: "Search by Status",
			disabled: false,
			isObject: true,
			primaryKey: "id",
			labelKey: "name",
			singleSelect: true,
			selectAllOption: false,
			defaultAllSelected: false,
			prevId: "user",
			nextId: "submitBTN",
		};
	};

	const handleAlert = (msg) => {
		setShowAlert(true);
		setAlertMsg(msg);
	};

	// for Export as excel
	const reportExcelExport = async () => {
		try {
			setReportTableData([]);
			const body = {
				UserID: selData?.user?.length === 1 ? selData?.user?.[0]?.UserID : 0,
				FromDate: selData?.bookedDate,
				Status: selData?.status?.[0]?.id,
				BranchID: selData?.busStation.length === 1 ? selData?.busStation?.[0]?.BranchID : 0,
				CounterID: selData?.counter?.length === 1 ? selData?.counter?.[0]?.CounterID : 0,
			};
			dispatch(getPOSBankGatewayReportData(body)).then(async (res) => {
				if (res?.status === 200 && res?.data?.status) {
					let reportData = [];
					if (res?.data?.Data?.Table?.length > 0) {
						reportData = res.data?.Data?.Table?.map((val, i) => ({
							...val,
							isDataRow: true,
							SN: i + 1,
							BkgDate: moment(val.BkgDate).format("DD-MMM-YYYY"),
							JDate: moment(val.JDate).format("DD-MMM-YYYY"),
							SeatCount: val.SeatNos?.split(",")?.length,
						}));
						const keys = ["Amount", "SeatNos"];
						const totals = getTotalByKey(reportData, keys);
						totals.POS_OrderID = "GRAND TOTAL";
						totals.totalCaption = "GRAND TOTAL";
						totals.SeatNos = totals.SeatNos;
						totals.isTotalRow = true;
						totals.colSpan =
							selData.status?.[0]?.id === "S" ? 3 : 4;
						reportData.push(totals);
					}
					let xlColumns = [];
					if (selData?.status?.[0]?.id === "S") {
						xlColumns = columnDefs3.map((col) => {
							return {
								colHeader: col.exportHead,
								field: col.field,
								xlCol: col.xlCol,
							};
						});
					} else if (selData?.status?.[0]?.id === "F") {
						xlColumns = columnDefs2.map((col) => {
							return {
								colHeader: col.exportHead,
								field: col.field,
								xlCol: col.xlCol,
							};
						});
					}

					const xlConfig = {
						...excelConfig,
						columns: xlColumns,
						fileName: `Bank_GateWay_Wise_Booking_Statement_${selData?.status?.[0]?.id === "S"
							? "Success"
							: "Failure"
							}.xlsx`,
						showFilterSection: true,
						showSummarySection: true,
						showEmptyRow: true,
						headerRowStyle: { fill: "", bold: true },
						borderStyle: {
							top: { style: "thin" },
							left: { style: "thin" },
							bottom: { style: "thin" },
							right: { style: "thin" },
						},
						showHeader: true,
						workSheetTitle: `POS_Bank_GateWay_Wise_Booking_Statement_${selData?.status?.[0]?.id === "S"
							? "Success"
							: "Failure"
							}`,
						headerFooter: {
							firstHeader: `POS_Bank_GateWay_Wise_Booking_Statement_${selData?.status?.[0]?.id === "S"
								? "Success"
								: "Failure"
								}`,
							firstFooter: `POS_Bank_GateWay_Wise_Booking_Statement_${selData?.status?.[0]?.id === "S"
								? "Success"
								: "Failure"
								}`,
						},
						sheetHeaderData: [
							{
								caption:
									"KARNATAKA STATE ROAD TRANSPORT CORPORATION",
								colSpan:
									selData.status?.[0]?.id === "S" ? 13 : 15,
								horizontal: "center",
								newRow: true,
							},
							{
								caption:
									selData?.status?.[0]?.id === "S"
										? "POS Bank/GateWay Wise Booking Statement/Success"
										: selData?.status?.[0]?.id === "F" &&
										"Bank/GateWay Wise Booking Statement/Failure",
								colSpan:
									selData.status?.[0]?.id === "S" ? 13 : 15,
								size: 12,
								horizontal: "center",
								newRow: true,
							},
							{
								caption: `Bus Station: ${selData.busStation.length > 1
									? "All"
									: selData.busStation?.[0]?.BranchName
									}`,
								colSpan:
									selData.status?.[0]?.id === "S" ? 6 : 7,
								size: 10,
								horizontal: "left",
							},
							{
								caption: "",
								value: ``,
								colSpan: 1,
							},
							{
								caption: `User : `,
								value: `${user?.UserName || ""} (${sessionStorage.getItem("LoginId") || ""
									})`,
								colSpan:
									selData.status?.[0]?.id === "S" ? 6 : 7,
								horizontal: "right",
								size: 10,
								newRow: true,
							},
							{
								caption: " Counter :",
								value: `${selData?.counter.length > 1
									? "All"
									: selData?.counter?.[0]?.CounterName
									}`,
								colSpan:
									selData.status?.[0]?.id === "S" ? 6 : 7,
								horizontal: "left",
								size: 10,
							},
							{
								caption: "",
								value: ``,
								colSpan: 1,
							},
							{
								caption: `Print Date & Time : `,
								value: `${currentDateTime}`,
								colSpan:
									selData.status?.[0]?.id === "S" ? 6 : 7,
								horizontal: "right",
								size: 10,
								newRow: true,
							},
							{
								caption: `TRANSACTIONS STATUS: ${selData?.status?.[0]?.name
									}, BOOKED DATE: ${moment(
										selData?.bookedDate
									).format("DD-MMM-YYYY")}`,
								value: ``,
								colSpan:
									selData.status?.[0]?.id === "S" ? 13 : 15,
								horizontal: "right",
								size: 10,
							},
						],
					};
					await excelExport.processExcel(xlConfig, reportData);
				} else {
					handleAlert(res.data?.Message);
				}
			});
		} catch (err) {
			console.log(err);
		}
	};

	const printReport = async (isSave) => {
		setReportTableData([]);
		const body = {
			UserID: selData?.user?.length === 1 ? selData?.user?.[0]?.UserID : 0,
			FromDate: selData?.bookedDate,
			Status: selData?.status?.[0]?.id,
			BranchID: selData?.busStation.length === 1 ? selData?.busStation?.[0]?.BranchID : 0,
			CounterID: selData?.counter?.length === 1 ? selData?.counter?.[0]?.CounterID : 0,
		};
		dispatch(getPOSBankGatewayReportData(body)).then((res) => {
			if (res?.status === 200 && res?.data?.status) {
				let reportData = [];
				if (res?.data?.Data?.Table?.length > 0) {
					reportData = res.data?.Data?.Table?.map((val, i) => ({
						...val,
						isDataRow: true,
						SN: i + 1,
						BkgDate: moment(val.BkgDate).format("DD-MMM-YYYY"),
						JDate: moment(val.JDate).format("DD-MMM-YYYY"),
						SeatCount: val.SeatNos?.split(",")?.length,
					}));
					const keys = ["Amount", "SeatNos"];
					const totals = getTotalByKey(reportData, keys);
					totals.POS_OrderID = "GRAND TOTAL";
					totals.totalCaption = "GRAND TOTAL";
					totals.SeatNos = totals.SeatNos;
					totals.isTotal = true;
					totals.colSpan = 3;
					reportData.push(totals);
				}
				jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
				jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);
				let pdfColumns = [];
				if (selData?.status?.[0]?.id === "S") {
					pdfColumns = columnDefs3.map((col) => {
						return {
							header: col.headerName,
							dataKey: col.field,
							xlCol: col.xlCol,
							headerSx: col.headerSx,
						};
					});
				} else if (selData?.status?.[0]?.id === "F") {
					pdfColumns = columnDefs2.map((col) => {
						return {
							header: col.headerName,
							dataKey: col.field,
							xlCol: col.xlCol,
							headerSx: col.headerSx,
						};
					});
				}

				const widthCell = calculateTotalTableWidth(columnDefsPDF);
				const doc = new jsPDF({
					orientation: pdfColumns.length > 12 ? "l" : "p",
					format:
						pdfColumns.length > 12
							? calculateDynamicFormatLandscape(
								(widthCell > 1122 ? widthCell : 1122) + 60
							)
							: calculateDynamicFormatPortrait(
								(widthCell > 793 ? widthCell : 793) + 60
							),
					unit: "px",
					compress: true,
				});
				doc.autoTableSetDefaults({
					headStyles: {
						fontSize: 6,
						width: "auto",
						halign: "right",
						fillColor: [30, 89, 167],
					},
				});
				var totalPagesExp = "{total_pages_count_string}";
				doc.setProperties({
					title: `Online Report.pdf`,
					subject: "Report",
					author: "Karnataka State Road Transport Corporation",
					keywords: "Mantis Technologies Private Limited",
					creator: "KSRTC",
				});

				const startY = 180;
				autoTable(doc, {
					margin: { top: 0, left: 20, right: 20, bottom: 3 },
					startY: startY,
					theme: "grid",
					head: [],
					body: [[]],
					didDrawPage: function (data) {
						var doc = data.doc;
						doc.setTextColor("#000000");

						// Calculate text width and center for the first text
						var text1 =
							"KARNATAKA STATE ROAD TRANSPORT CORPORATION";
						var textWidth1 =
							(doc.getStringUnitWidth(text1) *
								doc.internal.getFontSize()) /
							doc.internal.scaleFactor;
						var centerX1 =
							(doc.internal.pageSize.width - textWidth1) / 2;

						// Set font size and style for the first text
						doc.setFontSize(18).setFont("Roboto", "normal", "700");
						doc.setTextColor("#000000");
						// Draw the first text at the calculated x-coordinate
						doc.text(text1, centerX1, 60);

						// Set font size, weight, and color for the second text
						doc.setFontSize(18).setFont("Roboto", "normal", "600");
						doc.setTextColor("#000000");
						// Calculate text width and center for the second text
						var text2 =
							"POS BANK/GATEWAY WISE BOOKING STATEMENT/SUCCESS";
						var textWidth2 =
							(doc.getStringUnitWidth(text2) *
								doc.internal.getFontSize()) /
							doc.internal.scaleFactor;
						var centerX2 =
							(doc.internal.pageSize.width - textWidth2) / 2;
						// Draw the second text at the calculated x-coordinate below the first text
						doc.text(text2, centerX2, 80); // Adjust the vertical position as needed
						doc.setTextColor(0, 0, 0);
						doc.setFontSize(18);
						doc.setFont("Roboto", "");
						doc.text(
							`Bus Station:  ${selData?.busStation.length > 1
								? "All"
								: selData?.busStation?.[0].BranchName
							}`,
							30,
							145
						);
						doc.setFontSize(18);
						doc.setFont("Roboto", "");
						doc.text(
							`Counter : ${selData.counter.length > 1
								? "All"
								: selData?.counter?.[0].CounterName
							}`,
							30,
							170
						);
						doc.setFontSize(18);
						doc.setFont("Roboto", "");
						doc.text(
							`User: ${user?.UserName || ""} (${sessionStorage.getItem("LoginId") || ""
							})`,
							doc.internal.pageSize.width -
							data.settings.margin.left,
							125,
							"right"
						);
						doc.text(
							`Print Date & Time: ${currentDateTime}`,
							doc.internal.pageSize.width -
							data.settings.margin.left,
							145,
							"right"
						);
						doc.text(
							`TRANSACTIONS STATUS: ${selData?.status?.[0]?.name
							}, BOOKED DATE: ${moment(
								selData?.bookedDate
							).format("DD-MMM-YYYY")}`,
							doc.internal.pageSize.width -
							data.settings.margin.left,
							170,
							"right"
						);
					},
				});
				autoTable(doc, {
					startY: doc.lastAutoTable.finalY,
					margin: { top: 20, left: 20, right: 20, bottom: 20 },
					alternateRowStyles: {
						fillColor: [255, 255, 255],
					},
					columns: pdfColumns,
					body: reportData,

					columnStyles:
						selData?.status?.[0]?.id === "S"
							? {
								0: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								1: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								2: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								3: {
									halign: "right",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								4: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								5: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								6: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								7: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								8: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								9: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								10: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								11: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								12: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
							}
							: selData?.status?.[0]?.id === "F" && {
								0: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								1: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								2: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								3: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								4: {
									halign: "right",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								5: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								6: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								7: {
									halign: "right",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								8: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								9: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								10: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								11: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								12: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								13: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								14: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
								15: {
									halign: "left",
									fontSize: 13,
									valign: "middle",
									minCellWidth: 10,
									font: "Roboto",
									textColor: [0, 0, 0],
									fontStyle: "normal",
								},
							},
					// showHead: 'never',
					theme: "grid",
					styles: {
						lineWidth: [0, 0.2, 0, 0.6],
					},
					tableLineWidth: 0.6,
					headStyles: {
						fontSize: 16,
						fillColor: [255, 255, 255],
						textColor: [0, 0, 0],
						cellPadding: 6,
						valign: "middle",
						fontStyle: "normal",
						font: "Roboto",
					},
					didParseCell: (data) => {
						// drawCell(data)
						if (data.row.section === "head") {
							if (
								["number", "quantity", "currency"].indexOf(
									data.column.raw.xlCol.dataType
								) !== -1
							) {
								data.cell.styles.halign = "right";
							} else {
								data.cell.styles.halign = "left";
							}
						}
					},
				});
				doc.setFont("Roboto");

				if (typeof doc.putTotalPages === "function") {
					doc.putTotalPages(totalPagesExp);
				}
				if (selData?.status?.[0]?.id === "S") {
					doc.save(
						`POS Bank GateWay Wise Booking Statement Success Report ${new Date().getTime()}.pdf`
					);
				} else if (selData?.status?.[0]?.id === "F") {
					doc.save(
						`POS Bank GateWay Wise Booking Statement Failure  Report ${new Date().getTime()}.pdf`
					);
				}
			} else {
				handleAlert(res.data?.Message);
			}
		});
	};

	const handleSumbit = async () => {
		setReportTableData([]);
		//setReportType(2);
		const body = {
			UserID: selData?.user?.length === 1 ? selData?.user?.[0]?.UserID : 0,
			FromDate: selData?.bookedDate,
			Status: selData?.status?.[0]?.id,
			BranchID: selData?.busStation.length === 1 ? selData?.busStation?.[0]?.BranchID : 0,
			CounterID: selData?.counter?.length === 1 ? selData?.counter?.[0]?.CounterID : 0,
		};
		dispatch(getPOSBankGatewayReportData(body)).then((res) => {
			if (res?.status === 200 && res?.data?.status) {
				if (res?.data?.Data?.Table?.length > 0) {
					setReportTableData(res?.data?.Data?.Table);
					if (selData?.status?.[0]?.id === "S") {
						setReportType(1);
					} else if (selData?.status?.[0]?.id === "F") {
						setReportType(2);
					}
				} else {
					handleAlert("No Data Found");
				}
			} else {
				handleAlert(res.data?.Message);
			}
		});
	};

	return (
		<>
			{reportType === 0 ? (
				<Box>
					<ReportHeader
						mainHeaderName="Report"
						headerName="Online Report"
						openSubMenu={() => dispatch(reportMenu(true))}
						subHeader={
							"POS Bank/GateWay Wise Booking Statement/Success"
						}
						subHeaderVisible={() =>
							dispatch(onlineReportMenu(true))
						}
						mainMenuOpen={true}
					/>
					<Grid
						container
						spacing={0}
						className="column-container"
						style={{
							padding: "16px 16px 58px 16px",
						}}
					>
						<Grid
							item
							md={6.5}
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "16px",
							}}
						>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									fontWeight: "700",
								}}
							>
								<Grid item md={4}>
									Booked Date
								</Grid>
								<Grid item md={8}>
									<CustomDatePicker
										label={""}
										id="bookedDate"
										selectedDate={selData?.bookedDate}
										onChange={(value) => {
											setSelData((prev) => ({
												...prev,
												bookedDate: formatDate(value),
											}));
										}}
										minDate={"2024-06-19"}
										onKeyDown={(e) => {
											navigation1(e, "station", "");
										}}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "700" }}>
									Bus Station
								</Grid>
								<Grid item md={8}>
									<MultiSelectDropDown
										{...busStationProps()}
										onSelect={(val) => {
											setSelData((prev) => ({
												...prev,
												busStation: val,
											}));
										}}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "700" }}>
									Counter
								</Grid>
								<Grid item md={8}>
									<MultiSelectDropDown
										{...counterProps()}
										onSelect={(val) => {
											setSelData((prev) => ({
												...prev,
												counter: val,
											}));
										}}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "700" }}>
									User
								</Grid>
								<Grid item md={8}>
									<MultiSelectDropDown
										{...userNameProps()}
										onSelect={(val) => {
											setSelData((prev) => ({
												...prev,
												user: val,
											}));
										}}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "700" }}>
									Status
								</Grid>
								<Grid item md={8}>
									<MultiSelectDropDown
										{...statusProps()}
										onSelect={(val) => {
											setSelData((prev) => ({
												...prev,
												status: val,
											}));
										}}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									gap: "10px",
									flexWrap: "nowrap",
								}}
							>
								<Grid item md={4}></Grid>
								<Grid item md={2}>
									<Button
										variant="contained"
										size="medium"
										id="submitBTN"
										className={`btn-orange`}
										onClick={() => handleSumbit()}
										onKeyDown={(e) =>
											navigation3(
												e,
												"pdfBTN",
												"status",
												() => handleSumbit()
											)
										}
									>
										SUBMIT
									</Button>
								</Grid>
								<Grid item md={2}>
									<Button
										variant="outlined"
										size="medium"
										id="pdfBTN"
										className="btn-orange-outline"
										onClick={() => printReport()}
										onKeyDown={(e) =>
											navigation3(
												e,
												"excelBTN",
												"submitBTN",
												() => {
													printReport();
												}
											)
										}
									>
										PDF
									</Button>
								</Grid>
								<Grid item md={2}>
									<Button
										variant="outlined"
										size="medium"
										className="btn-orange-outline"
										id="excelBTN"
										onClick={() => reportExcelExport()}
										onKeyDown={(e) =>
											navigation3(
												e,
												"resetBTN",
												"pdfBTN",
												() => {
													reportExcelExport();
												}
											)
										}
									>
										EXCEL
									</Button>
								</Grid>
								<Grid item md={2}>
									<Button
										variant="outlined"
										size="medium"
										id="resetBTN"
										className="btn-orange-outline"
										onClick={() => handleResetValue()}
										onKeyDown={(e) =>
											navigation3(
												e,
												"",
												"excelBTN",
												() => {
													handleResetValue();
												}
											)
										}
									>
										RESET
									</Button>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			) : reportType === 1 ? (
				<PosBankGateWayWiseSuccessStatementTable
					reportTableData={reportTableData}
					selData={selData}
					handleBack={() => {
						setReportTableData([]);
						setReportType(0);
					}}
				/>
			) : (
				reportType === 2 && (
					<PosBankGateWayWiseBookingStatementFailureTable
						reportTableData={reportTableData}
						selData={selData}
						handleBack={() => {
							setReportTableData([]);
							setReportType(0);
						}}
					/>
				)
			)}
			{showAlert && (
				<Alert
					msg={alertMsg}
					alertType={"error"}
					close={() => setShowAlert(false)}
					buttonText="Ok"
				/>
			)}
		</>
	);
};

export default PosbankGateWayWiseBookingStatement;
